import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import SunkenPanel from "../components/SunkenPanel";
import Home from "../pages/Home";
import About from "../pages/About";
import Projects from "../pages/Projects";
import Reading from "../pages/Reading";
import Contact from "../pages/Contact";

const Portfolio = () => {
  const { pathname } = useLocation();

  return (
    <SunkenPanel>
      <div className={`${pathname === "/" ? "paper" : "paper-soft"} w-full h-full`}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/reading" element={<Reading />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </div>
    </SunkenPanel>
  );
};

export default Portfolio;
